package org.lennycodes.gradematewebsite.pages

import androidx.compose.runtime.Composable
import com.varabyte.kobweb.compose.foundation.layout.Column
import com.varabyte.kobweb.compose.ui.Modifier
import com.varabyte.kobweb.compose.ui.modifiers.backgroundColor
import com.varabyte.kobweb.compose.ui.modifiers.fillMaxWidth
import com.varabyte.kobweb.core.Page
import org.lennycodes.gradematewebsite.components.*
import org.lennycodes.gradematewebsite.components.style.GradeMateColors


// ---------------------------------------------------------------------------
// Page
// ---------------------------------------------------------------------------
@Page
@Composable
fun HomePage() {
    Column(Modifier.fillMaxWidth().backgroundColor(GradeMateColors.Background)) {
        NavBar()
        HeroSection()
        DocumentationSection()
        DownloadsSection()
        ContactSection()
        Footer()


    }
}